import { useEffect, useState } from 'react';

const QUERIES = {
  mobileAndTablet: '(max-width: 1023px)',
  mobile: '(max-width: 767px)',
  tablet: '(min-width: 768px) and (max-width: 1023px)',
  laptop: '(min-width: 1024px) and (max-width: 1279px)',
  desktop: '(min-width: 1280px)',
};

export default function useBreakpoint() {
  const getMatches = () => {
    // Guard against SSR
    if (typeof window === 'undefined') {
      return {
        mobileAndTablet: false,
        mobile: false,
        tablet: false,
        laptop: false,
        desktop: false,
      };
    }

    const matches = {};
    for (const key in QUERIES) {
      matches[key] = window.matchMedia(QUERIES[key]).matches;
    }
    return matches;
  };

  const [state, setState] = useState(getMatches);

  useEffect(() => {
    const mqls = {};
    const handler = () => setState(getMatches());

    for (const key in QUERIES) {
      mqls[key] = window.matchMedia(QUERIES[key]);
      mqls[key].addEventListener('change', handler);
    }

    return () => {
      for (const key in mqls) {
        mqls[key].removeEventListener('change', handler);
      }
    };
  }, []);

  return state;
}
